import React from 'react';

const StaffCRM = React.lazy(() => import('pages/StaffCRM/StaffCRMPage'));

const StaffCRMRoute = [
  {
    path: '/crm-staff',
    exact: true,
    name: 'Công việc khách hàng',
    component: StaffCRM,
    function: 'CRM_STAFF',
  },
];

export default StaffCRMRoute;
